import {
  FiShield,
  FiLock,
  FiDollarSign,
  FiCalendar
} from "react-icons/fi";
import { useEffect, useState } from "react";
import "../../styles/HomeWhyChoose.css";

export default function HomeWhyChoose() {

  const testimonials = [
    {
      text:
        "Finding a solicitor used to be a nightmare of phone calls and uncertainty. This platform connected me with a brilliant family lawyer within minutes. The transparency and simplicity truly make it a game changer.",
      name: "Ritesh",
      role: "Business Owner, Leeds",
      img: "https://i.pravatar.cc/80?img=12"
    },
    {
      text:
        "From booking to consultation, everything was seamless and professional. The clear pricing structure and verified solicitors gave me complete confidence. I was able to connect with the right legal expert without delays or hidden charges.",
      name: "Ananya",
      role: "Startup Founder, London",
      img: "https://i.pravatar.cc/80?img=47"
    },
    {
      text:
        "I truly appreciated how quick, confidential, and reliable the service was. The platform removed the usual stress of searching for legal help and provided clear guidance throughout. I found the right solicitor without confusion or unnecessary follow-ups.",
      name: "Michael",
      role: "IT Consultant, Manchester",
      img: "https://i.pravatar.cc/80?img=33"
    }
  ];


  const [activeIndex, setActiveIndex] = useState(0);

  /* ==============================
     AUTO ROTATE
  ============================== */
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const activeTestimonial = testimonials[activeIndex];

  return (
    <section className="why-choose">
      <div className="why-container">
        <h2 className="why-title">Why <span style={{ color: "#d6b87c" }}>Choose Us</span></h2>
        <p className="why-subtitle">
          We prioritize your trust and security with every interaction.
        </p>

        {/* WHY CHOOSE GRID */}
        <div className="why-grid">
          <div className="why-card">
            <div className="why-icon">
              <FiShield />
            </div>
            <h3>Verified & Licensed</h3>
            <p>
              All solicitors are thoroughly vetted and verified for active
              practice.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FiLock />
            </div>
            <h3>Confidential</h3>
            <p>
              100% private consultations. Your legal matters stay between you.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FiDollarSign />
            </div>
            <h3>Transparent Fees</h3>
            <p>
              Clear pricing with no hidden charges or unexpected costs.
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FiCalendar />
            </div>
            <h3>Secure Booking</h3>
            <p>
              Easy and encrypted appointment booking system.
            </p>
          </div>
        </div>

        {/* TESTIMONIALS SECTION */}
        <div className="testimonials">
          <div className="testimonials-left">
            <span className="testimonials-tag">TESTIMONIALS</span>
            <h2>
              What Our Clients <br /> Are Saying
            </h2>
          </div>

          <div className="testimonials-right">
            <span className="big-quote">“</span>

            <div className="testimonial-content">
              <p>{activeTestimonial.text}</p>

              <div className="testimonial-user">
                <img
                  src={activeTestimonial.img}
                  alt={activeTestimonial.name}
                />
                <div>
                  <h4>{activeTestimonial.name}</h4>
                  <span>{activeTestimonial.role}</span>
                </div>
              </div>

              <div className="testimonial-dots">
                {testimonials.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${index === activeIndex ? "active" : ""}`}
                    onClick={() => setActiveIndex(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
